import {Brick, registerBrick} from 'olympe';

/**
 * This brick dynamically builds and applies filters for Olympe DB queries, converting input values into "ilike"
 * filter objects and setting them as JSON for database retrieval.
 */
export default class OGCreateBodyForOlympeDB extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {{filterColumn: string, filterValue: string|string[]}[]} values
     * @param {number} limit
     * @param {number} offset
     * @param {function()} forwardEvent
     * @param {function(Object)} setBody
     */
    update($, [values, limit, offset], [forwardEvent, setBody]) {
        const body = {
            limit: limit,
            offset: offset,
            count: true,
        };

        const filters = values.map((value) => {
            if (Array.isArray(value.filterValue)) { // We can have multiple values only for company code
                return value.filterValue.map((v, idx) => ({
                    field: value.filterColumn,
                    value: `%${v}%`,
                    operator: 'ilike',
                    group: idx,
                }));
            } else {
                const multipleCompanyCodes = values.find((v) => Array.isArray(v.filterValue));
                const group = Array.isArray(multipleCompanyCodes?.filterValue) ? Array.from(Array(multipleCompanyCodes.filterValue.length).keys()) : undefined;

                const filterToReturn = {
                    field: value.filterColumn,
                    value: `%${value.filterValue}%`,
                    operator: 'ilike',
                };
                if (group) {
                    filterToReturn.group = group;
                }
                return filterToReturn;
            }
        });

        setBody({...body, filters: filters.flat()});
        forwardEvent();
    }
}

registerBrick('0198f5e6bf1ccab8a515', OGCreateBodyForOlympeDB);
